// extracted by mini-css-extract-plugin
export default {"layout":"n4hMU","inner":"hMmkd","withBanner":"K3q5N"};